module.exports = __webpack_public_path__ + "img/ic-ideal.975db0db.svg";